import React from 'react';
import '../css/Blog.css';

const posts = [
  {
    title: 'Building Scalable Flask + React Apps',
    link: 'https://medium.com/@oz',
    tag: 'DevOps',
    img: 'https://miro.medium.com/v2/resize:fit:1400/0*zZ9WUP4tohTxyPMB.png'
  },
  {
    title: 'JWT Best‑Practices in 2025',
    link: 'https://dev.to/oz',
    tag: 'Security',
    img: 'https://cdn.prod.website-files.com/642bc0503c186417b1329fbc/6517b5bebcd16f92651813e7_SecOps%20Solution%20(49).jpg'
  },
  {
    title: 'MongoDB Aggregations You Should Know',
    link: 'https://blog.oz.dev',
    tag: 'Database',
    img: 'https://images.contentstack.io/v3/assets/bltac01ee6daa3a1e14/blte70834b1c4977e73/6777fbef1381a6828647f3cb/img_blog_BP-MT-Mastering-MongoDB-Aggregate-Count-A-Practical-Guide-for-Developers_new-primary.png?width=736&disable=upscale&auto=webp'
  },
];

export default function Blog() {
  return (
    <section id="blog" className="blog">
      <h2 className="blog-title">Latest&nbsp;Articles</h2>

      <div className="blog-grid">
        {posts.map((p,i)=>(
          <a href={p.link} key={i} className="blog-card" target="_blank" rel="noreferrer">
            <img src={p.img} alt={p.title}/>
            <div className="blog-content">
              <span className="blog-tag">{p.tag}</span>
              <h3>{p.title}</h3>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
